<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
</style>

<script>
import sizeReset from "../../common/commonJS/sizeReset.js";
export default {
  name: "app",
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {
    window.localStorage.chosenMark = " ";
    sizeReset.sizeReset();
    // setTimeout(() => {
    //   window.onresize();
    // }, 60);
    window.onresize = function temp() {
      sizeReset.sizeReset();
    };
  },
  methods: {}
};
</script>